<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-title>Admin</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <CPOCreation />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
// import CPOCreation from "@/components/corporate/CPOCreation.vue";
import CPOCreation from "@/components/admin/CPOCreation.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'cpoCreation',
    components: {
      CPOCreation, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
})
</script>